import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";
import {MesApiService} from "./mes-api.service";
import localforage from "localforage";
import {MesHttpStatusHandlerService} from "./mes-http-status-handler.service";
import {ApiResponse} from "./api-response/api-response.model";

export interface ICommonAppSettings {
  'AppVersion': '';
  'CacheVersion': '';
}

@Injectable({
  providedIn: 'root'
})
export class MesConfigService extends MesApiService {

  constructor(private mesHttpStatusHandlerService: MesHttpStatusHandlerService) {
    super('Config');
  }

  getChangelog(): Observable<string> {
    return this.getSingle({
      action: 'GetChangelog'
    }).pipe(map(value => {
      return value.data as string;
    }));
  }

  getCssString(): Observable<string> {
    return this.getSingle({
      action: 'GetCssString'
    }).pipe(map(value => {
      return value.data as string;
    }));
  }

  getSettings<T extends ICommonAppSettings>() {
    return this.getSingle<any>({
      action: 'GetSettings'
    }).pipe(map(value => {
      const settings = JSON.parse(value.data.AppSettings || '{}') as T;
      Object.assign(settings, value.data);
      const storedCacheVersion = this.mesHttpStatusHandlerService.getAppCacheVersion();
      if (storedCacheVersion && settings.CacheVersion !== storedCacheVersion) {
        console.log('Clear storage cache');
        this.clearStorageCache();
      }
      this.mesHttpStatusHandlerService.setAppCacheVersion(settings.CacheVersion);

      return settings;
    }));
  }

  resetCaches(): Observable<ApiResponse<any>> {
    return this.getSingle<any>({
      action: 'ClearCaches'
    }).pipe(tap(x => {
      this.clearStorageCache();
    }));
  }

  recycle(): Observable<ApiResponse<any>> {
    return this.getSingle<any>({
      action: 'Recycle'
    });
  }

  clearStorageCache() {
    localforage.clear().then(() => {
      this.mesHttpStatusHandlerService.setAppCacheVersion(null);
      setTimeout(() => window.location.reload(), 1000);
    });
  }
}
